import page from '../../../components/page'
import {api,imgPath} from "../../../common/config";
import {ajaxUtil} from "../../../common/AjaxUtil";
import {store} from "../../../store/store";
import {CommonUtil} from "../../../common/CommonUtil";
import {StorageUtil} from "../../../common/Auth";

export default {
    name: 'borrow',
    data() {
        return {
          imgPath:imgPath,
            isPay: false,//控制赔书弹出框
            listBook: [],
            idCard: store.func.getUserIdCard(),
            totalPage: 1,
            imgError: store.imgError,
            pageCount: 4,
            pageNo:1,
            borrowType: 2,//0 全部，1 当前借阅，2历史借阅
            typeId: 1   //1新增   2修改
        }
    },
    watch: {
        $route() {
            this.getList();
        }
    },
    components: {
        page
    },
    beforeMount() {
        store.personal._this.activeNav = "历史借阅";
        this.getList();
    },
    methods: {
        getList() {
            this.pageNo = this.$route.query.page || 1;
            var url = api.readerBorrower.list.replace('{pageNo}', this.pageNo).replace('{pageCount}', this.pageCount)
                .replace('{idCard}', this.idCard).replace('{borrowType}', this.borrowType);
            ajaxUtil.ajaxJson(url, null, "GET", (data) =>  {
                if (data.resultList != null) {
                    var resultList = data.resultList;
                    for (let i = 0; i < resultList.length; i++) {
                        if (resultList[i].borrowState == 6) {
                            resultList[i].borrowState = "";
                        } else if (resultList[i].borrowState == 7) {
                            resultList[i].borrowState = "已赔书";
                        } else if (resultList[i].borrowState == 28) {
                            resultList[i].borrowState = "已购买";
                        }
                    }
                    this.listBook = resultList;
                }
                this.totalPage = data.totalPage;
            }, null, this);
        },
        //翻页操作
        pageChange(pageNo) {
            CommonUtil.mergeQuery(this,{page: pageNo});
        },
        editNote(item) {
          this.$router.push({path: '/editnote', query: { 'bookName': item.bookName, 'bookId': item.bookId, 'typeId': this.typeId }})
        },
        /*打开赔书弹出框*/
        compensation() {
            this.isPay = true
        },
        /*关闭赔书弹出框*/
        del() {
            this.isPay = false
        },
        /*点赞功能*/
        onPraise(index, id) {
            var isPraiseD = this.listBook[index].isPraiseD;
            if (isPraiseD == 0) {
                isPraiseD = 1;
            } else {
                isPraiseD = 0;
            }
            //post
            var url = api.readerBorrower.like;
            var data = {
                borrowerBookId: id,
                praise: isPraiseD,
            };
            ajaxUtil.ajaxJson(url, data, "POST", (data) => {
                this.listBook[index].isPraiseD = isPraiseD;
            }, (result) => {
                CommonUtil.setInfo("点赞失败，请稍后重试!");
            }, this);
        },
    }
}
